export default "__VITE_ASSET__44afd6a6__"